import { BmHttp } from "../utils/Global"


// ADMINISTRATIVO-BUSCADOR-01: `search` es opcional y viaja al SERVIDOR -- la
// pantalla se pagina en servidor, asi que filtrar en el navegador solo buscaria
// dentro de la pagina visible.
export const Listarusers = async ({page = 1, limit = 10, search = ""}) => {
    try {
        const {data} = await BmHttp().get('users_all', {
            params: {page, limit, ...(search ? {search} : {})}
        })
        return data
    } catch (error) {
        console.log(error)
    }
}

export const ListaruserSinPagineo = async () => {
    try {
        const {data} = await BmHttp().get('users_alls')
        return data
    } catch (error) {
        console.log(error)
    }
}

export const Actualizaruser = async (user) => {
    try {
        const {data} = await BmHttp().put('users', user)
        return data
    } catch (error) {
        console.log(error)
    }
}

export const Crearuser = async (user) => {
    try {
        const {data} = await BmHttp().post('users', user)
        return data
    } catch (error) {
        console.log(error)
    }
}

export const Eliminaruser = async (id) => {
    try {
        const {data} = await BmHttp().delete('users/'+id)
        return data
    } catch (error) {
        console.log(error)
    }
}

export const ServiceLogin = async (user) => {
    try {
        const {data} = await BmHttp().post('login', user)
        return data
    } catch (error) {
        console.log(error)
        return {
            success: false,
            token: null,
            message: error.response?.data?.message || "No se pudo iniciar sesión. Verifique que el servidor esté disponible.",
            error: error.response?.data || error.message
        }
    }
}

export const CambiarRolUsuario = async (iduser, payload) => {
    const {data} = await BmHttp().put('users/'+iduser+'/role', payload)
    return data
}
